import { adaptV4Theme, createTheme } from '@mui/material/styles';
// See https://material-ui.com/customization/color/
// See https://cimdalli.github.io/mui-theme-generator/

export const theme = createTheme(
  adaptV4Theme({
    palette: {
      primary: { main: '#4790CC' },
      secondary: { main: '#4CEFDA' },
      info: { main: '#047D95' },
      action: {
        disabledBackground: '#919293',
      },
    },
  }),
);

export default theme;
